import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postDocumentFile } from '../../requests/postDocumentFile';
import { DocumentParams } from '../../types/DocumentParams';

export const useCreateDocumentFile = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      documentId,
      documentParams,
      file,
    }: {
      documentId: string;
      documentParams: DocumentParams;
      file: File;
    }) => postDocumentFile(constructPost, documentId, documentParams, file),
  });

  return { createDocumentFile: mutateAsync, isPending };
};
